import { render, staticRenderFns } from "./ProjectRequestResponse.vue?vue&type=template&id=79a877f8&"
import script from "./ProjectRequestResponse.vue?vue&type=script&lang=js&"
export * from "./ProjectRequestResponse.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRequestResponse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports